module.exports = __webpack_public_path__ + "img/gather sleeve opening.d841a6f5.png";